import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {NUM_AMPLITUDES} from '../Constants';
import range from 'lodash/range';
import {Button} from 'react-bootstrap';

export default class AmplitudePicker extends Component {
    static propTypes = {
        amplitude: PropTypes.number,
        onChange: PropTypes.func,
    };

    render() {
        const {amplitude, onChange} = this.props;
        return (
            <div className="amplitude-picker">
                <div className="choice-label" title={'Amplitude'}>{'Amp'}</div>
                {
                    range(NUM_AMPLITUDES, 0, -1).map(n => (
                        <Button
                            key={`amp${n}`}
                            onClick={(e) => onChange(n)}
                            active={amplitude === n}
                            className="amp-button"
                            bsSize="sm"
                        >
                            {n}
                        </Button>
                    ))
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AmplitudePicker.js